<template>
  <div>
    <b-card bg-variant="light">
    <!-- <h1 id="jump-to-header">{{heading || "View"}}</h1> -->
      <b-row>
        <b-col md="4">
          <showing-show :id="id" @gotAttrs="assignAttrs"></showing-show>
        </b-col>
        <b-col md="3">
          <div v-if="attrs">
            <collection-image-carousel-index
              :filtering="product_item_filtering"
            ></collection-image-carousel-index>
          </div>
        </b-col>
        <b-col md="5">
          <b-tabs
            active-nav-item-class="font-weight-bold text-uppercase text-warning"
            active-tab-class="font-weight-bold text-success"
            content-class="mt-3"
            lazy
          >
            <b-tab title="Browse">
              <div v-if="attrs">
                <item-image-association-card-index
                  :filtering="item_image_association_filtering">
                </item-image-association-card-index>
              </div>
            </b-tab>
            <b-tab title="Search" active>
              <div v-if="attrs">
                <product-item-index
                  :filtering="product_item_filtering">
                </product-item-index>
              </div>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import ShowingShow from './ShowingShow.vue'
import ItemImageAssociationCardIndex from './ItemImageAssociationCardIndex.vue'
import CollectionImageCarouselIndex from './CollectionImageCarouselIndex.vue'
import ProductItemIndex from './ProductItemIndex.vue'

export default {
  components: {
    ShowingShow,
    ItemImageAssociationCardIndex,
    CollectionImageCarouselIndex,
    ProductItemIndex
  },
  props: {
    id: String,
    heading: {
      Type: String
    }
  },
  data () {
    return {
      product_item_filtering: {
        storage_space_subtree_ids: undefined
      },
      item_image_association_filtering: {
        storage_space_subtree_ids: undefined
      },
      attrs: undefined,
    }
  },
  methods: {
    assignAttrs(attrs) {
      this.attrs = Object.assign( {}, attrs)
      this.product_item_filtering.storage_space_subtree_ids = this.attrs['storage-space-id']
      this.item_image_association_filtering.storage_space_subtree_ids = this.attrs['storage-space-id']
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>